import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GoArrowRight, GoArrowLeft } from "react-icons/go";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getDreamCasinoGames } from "../../redux/slices/games/casino/dreamCasinoGameListSlice";
import { useDispatch, useSelector } from "react-redux";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

export default function InstantGames({
  setIsPopupOpen,
  setSelectedGame,
  isToggled,
  setIsToggled,
}) {
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(4);
  const [isLoading, setIsLoading] = useState(true);
  const { data: profileData } = useSelector((state) => state.getProfile);

  const getData = (pageNumber) => {
    setIsLoading(true);

    dispatch(
      getDreamCasinoGames({
        page: pageNumber,
        limit: 10,
        perpage: 10,
        search_by_category: "instant",
        search_by_provider: "",
        search_by_text: "",
        is_popular: 0,
        parent_user_id: profileData?.user?.parent_user_id,
      })
    )
      .unwrap()
      .then((res) => {
        setCategories(res.data);
        const validatedGames = res?.data?.map((game) => ({
          ...game,
          isBroken: false, // flag for broken thumbnails
        }));

        validatedGames?.forEach((game, idx) => {
          const img = new Image();
          img.src = game?.url_thumb;

          img.onload = () => {
            setCategories((prev) => {
              const copy = [...prev];
              copy[idx] = { ...game, isBroken: false }; // ✅ valid image
              return copy;
            });
            setIsLoading(false);
          };

          img.onerror = () => {
            setCategories((prev) => {
              const copy = [...prev];
              copy[idx] = { ...game, isBroken: true }; // ❌ broken → mark
              return copy;
            });
            setIsLoading(false);
          };
        });
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Failed :", error);
      });
  };
  useEffect(() => {
    getData(1);
  }, []);
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const containerWidth = entry.contentRect.width;
        const MIN_SLIDE_WIDTH = 100;
        const calculatedSlides = Math.max(
          2,
          Math.floor(containerWidth / MIN_SLIDE_WIDTH)
        );
        setSlidesToShow(calculatedSlides);
      }
    });

    const container = document.querySelector(".instant-game-slider-container");
    if (container) {
      resizeObserver.observe(container);
    }

    return () => resizeObserver.disconnect();
  }, []);
  const scroll = (direction) => {
    const scrollAmount = 250;
    if (current < categories?.length && direction == "right") {
      setCurrent(current + 1);
    }
    if (current > 0 && direction == "left") {
      setCurrent(current - 1);
    }

    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: direction == "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  return (
    <div
      className="carousel-container"
      style={{ background: "#0D131F", borderRadius: "10px !important" }}
    >
      <div className="carousel-header">
        <div className="d-flex justify-content-between">
          <span className="text-white fs-10 text-capitalize">
            Instant Games
          </span>
          {window.innerWidth >= 1024 && (
            <div className="d-flex align-items-center">
              <span
                className="mx-1"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "1.2rem",
                  height: "1.2rem",
                  borderRadius: "50%",
                  border: "1px solid gray",
                  cursor: current == 0 ? "not-allowed" : "pointer",
                  opacity: current == 0 ? 0.5 : 1,
                }}
                onClick={() => current > 0 && scroll("left")}
              >
                <GoArrowLeft size={12} />
              </span>

              <span
                className="mx-1"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "1.2rem",
                  height: "1.2rem",
                  borderRadius: "50%",
                  border: "1px solid gray",
                  cursor:
                    current >= categories?.length ? "not-allowed" : "pointer",
                  opacity: current >= categories?.length ? 0.5 : 1,
                }}
                onClick={() => scroll("right")}
              >
                <GoArrowRight size={12} />
              </span>
            </div>
          )}

          {window.innerWidth < 1024 && (
            <div className="d-flex align-self-end">
              <span
                className="see-all fs-10 d-flex text-start"
                onClick={() => {
                  setIsToggled(!isToggled);
                  document.body.classList.remove("no-scroll");
                  navigate("/instant-game-list");
                }}
              >
                View All
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="position-relative instant-game-slider-container">
        <MultiImageSlider
          banners={categories}
          setCurrent={setCurrent}
          current={current}
          slidesToShow={slidesToShow}
          from={"instant-game"}
          setIsPopupOpen={setIsPopupOpen}
          setSelectedGame={setSelectedGame}
          isToggled={isToggled}
          setIsToggled={setIsToggled}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

const MultiImageSlider = ({
  banners,
  setCurrent,
  current,
  slidesToShow,
  from,
  setIsPopupOpen,
  setSelectedGame,
  isToggled,
  setIsToggled,
  isLoading,
}) => {
  const sliderRef = useRef(null);
  const [previous, setPrevious] = useState(0);
  const navigate = useNavigate();
  const { data: profileData } = useSelector((state) => state.getProfile);
  useEffect(() => {
    if (current > previous) {
      sliderRef.current?.slickNext();
    }
    if (current < previous) {
      sliderRef.current?.slickPrev();
    }
  }, [current]);

  const containerRef = useRef(null);

  useEffect(() => {
    if (current > previous) sliderRef.current?.slickNext();
    if (current < previous) sliderRef.current?.slickPrev();
  }, [current]);

  const settings = {
    infinite: true,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true,
    pauseOnHover: false,
    cssEase: "ease-in-out",
    swipe: true,
    swipeToSlide: true,
    draggable: true,
    touchMove: true,
    centerMode: false,
    variableWidth: false,

    appendDots: (dots) => (
      <div className="custom-dots-container">
        <ul className="custom-dots-list">
          {dots.map((dot, index) => (
            <li
              key={index}
              className={`my-custom-dot-li ${dot.props.className}`}
            >
              {dot.props.children}
            </li>
          ))}
        </ul>
      </div>
    ),
    customPaging: () => <div className="custom-dot"></div>,
    beforeChange: (oldIndex, newIndex) => {
      setPrevious(newIndex + 1);
      setCurrent(newIndex + 1);
    },
  };

  return (
    <div
      className="instant-game-slider"
      ref={containerRef}
      style={{ width: "100%", margin: "0 auto" }}
    >
      {isLoading ? (
        <div className="d-flex gap-2">
          <SkeletonTheme baseColor="#2a2d3e" highlightColor="#3e4259">
            {[...Array(3)].map((_, i) => (
              <Skeleton
                key={i}
                width={100}
                height={window.innerWidth > 1024 ? 75 : 100}
                style={{
                  objectFit: window.innerWidth > 1024 ? "fill" : "",
                  border: "1px solid #3a3f5c",
                  borderRadius: "10px",
                  background: "rgba(245, 247, 250, 0.12)",
                  cursor: "pointer",
                }}
              />
            ))}
          </SkeletonTheme>
        </div>
      ) : banners?.length > 0 ? (
        <Slider ref={sliderRef} {...settings}>
          {banners.map((item, index) => (
            <div
              key={index}
              style={{ padding: "0 4px" }}
              onClick={() => {
                if (profileData) {
                  setSelectedGame(item);
                  setIsPopupOpen(true);
                  // navigate("/game-launch", {
                  //   state: { game_id: item?._id, game: item },
                  // });
                } else {
                  navigate("/");
                  sessionStorage.setItem("fromLogin", "true");
                  if (window.innerWidth < 1024) {
                    setIsToggled(!isToggled);
                  }
                }
              }}
            >
              <img
                src={item?.url_thumb}
                alt={`Slide ${index}`}
                className="rounded-1"
                style={{
                  width: "82%", // ✅ fills sidebar column
                  height: window.innerWidth > 1024 ? "75px" : "85px",
                  objectFit: window.innerWidth > 1024 ? "fill" : "", // ✅ no cutting/stretching
                  border: item?.isBroken ? "1px solid #3a3f5c" : "none",
                  borderRadius: item?.isBroken ? "10px" : "none",
                  display: item?.isBroken ? "block" : "",
                  alignContent: item?.isBroken ? "center" : "",
                  background: item?.isBroken ? "rgba(245, 247, 250, 0.12)" : "",
                  cursor: "pointer",
                }}
              />
            </div>
          ))}
        </Slider>
      ) : (
        <span className="d-flex fs-10 justify-content-center text-white">
          No Data Found
        </span>
      )}
    </div>
  );
};
